import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { animated } from 'react-spring'
import { setTermState, setInitialQuota } from 'context/reducer/quota'
import { Grid } from '@mui/material'
import { RootState } from 'context'
import { quotaSingleFormula } from 'utils/quotaFormula'
import { QuotaState } from 'interfaces/quota'
import { CreditDetail } from '../credit-detail'
import { DEBOUNCE_TIMER } from 'constants/index'
import './index.css'
import useFadeInFromAvobe from 'hooks/useFadeInFromAvobe'

export const TermInput = () => {
  const dispatch = useDispatch()
  const props = useFadeInFromAvobe(0)

  const { amount } = useSelector<RootState, QuotaState>((state) => state.quota)
  const [inputError, setinputError] = useState<boolean>(false)
  const [termValue, setTermValue] = useState('')
  const [term, setTerm] = useState<any | null>(null)
  const [calcQuota, setCalcQouta] = useState<boolean>(false)

  const handleOnChange = (event: any) => {
    const currentValue = event.target.value
    const isSpaceBar = currentValue.charCodeAt(currentValue.length - 1) === 32
    if (currentValue.length <= 2 && !isNaN(currentValue) && !isSpaceBar) {
      setinputError(false)
      if (
        +currentValue > 60 ||
        (+currentValue < 3 && currentValue.length > 0)
      ) {
        setinputError(true)
        setCalcQouta(false)
      } else {
        setCalcQouta(true)
      }
      setTermValue(currentValue)
    } else {
      setTermValue((val) => val)
    }
  }

  useEffect(() => {
    const termHandler = () => {
      if (!calcQuota || !termValue) {
        return setTerm(null)
      }
      const capital = parseInt(amount.replaceAll('.', ''),10)
      const quota = quotaSingleFormula(capital, parseInt(termValue,10))
      setTerm({
        ...quota,
        quotaText: quota.quota,
        interes: quota.totalInterest,
      })
    }
    const debouncer = setTimeout(() => {
      termHandler()
    }, DEBOUNCE_TIMER)

    return () => {
      clearTimeout(debouncer)
    }
  }, [termValue, amount, calcQuota])

  useEffect(() => {
    dispatch(setTermState(`${term?.term}`))

    dispatch(setInitialQuota(term?.quota))
  }, [term, dispatch])

  return (
    <div>
      <animated.div style={props}>
        <div className="bp-mt-16 bp-mb-16">
          <pichincha-typography
            align="center"
            variant={'smallText'}
            weight="bold"
            color="Grayscale"
            weight_color="500"
          >
            Escribe entre 3 y 60 meses para simular
          </pichincha-typography>
        </div>
        <Grid
          container
          justifyContent="center"
        >
          <Grid
            container
            justifyContent="center"
            className={`input-container bp-mb-12 ${inputError && 'input-border-danger'}`}>
            <Grid item xs={8}>
              <input
                className="input-term"
                type="tel"
                value={termValue}
                onChange={handleOnChange}
              ></input>
            </Grid>
            <Grid item xs={4}>
              <div
                className={`semibold input-adorment ${inputError ? 'input-adorment-danger' : 'input-adorment-white'}`}
              >
                Meses
              </div>
            </Grid>

          </Grid>
        </Grid>
        {inputError && (
          <div className="error-input">
            Valor no permitido, ingresa un número entre 3 y 60 meses.
          </div>
        )}
        {term && <CreditDetail term={term}></CreditDetail>}
      </animated.div>
    </div>
  )
}
